<template>
  <div class="testimonial-content ptb-100">
    <div class="container">
      <div class="edu-section-title text-center">
        <p class="sub-title">Katılımcı Yorumu</p>
        <h2>
          Öğrencilerimizden Değerli <span class="shape02">Yorumlar</span>
        </h2>
      </div>

      <div class="row justify-content-center">
        <!-- 1. Yorum -->
        <div class="col-lg-6 col-md-12">
          <div class="single-testimonial-box">
            <p class="feedback">
              “Benim için gerçekten en iyi çözüm oldu”
            </p>
            <p class="description">
              Eğitim süreci boyunca hem teorik hem de pratik bilgiler edindim.
              Kariyerimde yeni bir bakış açısı kazandırdı.
            </p>
            <h3>Ali Çoban</h3>
            <span>Yazılım Geliştirici</span>
          </div>
        </div>

        <!-- 2. Yorum -->
        <div class="col-lg-6 col-md-12">
          <div class="single-testimonial-box">
            <p class="feedback">
              “Eğitmenlerimizden en iyi tavsiyeleri aldım”
            </p>
            <p class="description">
              Ders içerikleri anlaşılır, destek ekibi her zaman yanımdaydı. Çok
              faydalı ve keyifli bir eğitim süreciydi.
            </p>
            <h3>Ayşe Yılmaz</h3>
            <span>UI/UX Tasarımcı</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TestimonialContent",
});
</script>

<style scoped>
.testimonial-content {
  background: #fff;
}

.single-testimonial-box {
  background: #fafafa;
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 20px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.single-testimonial-box .feedback {
  font-size: 18px;
  font-weight: 600;
  color: #111;
  margin-bottom: 10px;
}

.single-testimonial-box .description {
  font-size: 15px;
  color: #666;
  margin-bottom: 15px;
}

.single-testimonial-box h3 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 5px;
}

.single-testimonial-box span {
  font-size: 14px;
  color: #e74c3c;
}
</style>
